import useRankingTable from '../../../hooks/useRankingTable';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  clear_transactions_through_ccp_flag: {
    name: 'Direct clearing flag',
    isStatic: false
  },
  ranking: {
    name: 'Ranking (CCP)',
    isStatic: false
  },
  name: {
    name: 'Name of CCP with greatest exposure',
    isStatic: false
  },
  lei: {
    isStatic: false,
    name: 'LEI code of CCP with greatest exposure'
  },
  bic: {
    name: 'BIC code of CCP with greatest exposure',
    isStatic: false
  },
  exposure_value: {
    name: 'Exposure value of CCP with greatest exposure',
    isStatic: false
  }
};

export function ExposuresCPP({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.CCP_EXPOSURE,
    onChangeFund,
    schema: schema.CCP_EXPOSURE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.CCP_EXPOSURE?.field_names || [],
    tableName: 'CCP_EXPOSURE',
    order: 172,
    isMultiFunds,
    funds,
    columnLables
  });

  return (
    <StyledTables id="reporttables-exposures-cpp-group">
      {tables.map((rows, index) => (
        <Table
          key={index + 'CCP_EXPOSURE'}
          id={`reporttables-exposures-cpp-table-${index + 1}`}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
        />
      ))}
    </StyledTables>
  );
}
